<div class="row">
    <div class="col-12" [ngClass]="{'col-md-4': !modal}">
        <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
            <div class="page-section">
                <div class="page-section-header">
                    <h2 class="page-section-title">Add Unknown Payment</h2>
                </div>
                <div class="page-section-form">
                    <div class="mb-3">
                        <label for="bank" class="form-label">Bank <em>*</em></label>
                        <select class="form-select form-select-sm" name="bank" #bank="ngModel" [(ngModel)]="data.bank" required>
                            <option [value]="b.id" *ngFor="let b of banks;">{{b.title}} (RM {{b.balance}})</option>
                        </select>
                        <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                            <div *ngIf="bank.errors.required">Bank is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="payment" class="form-label">Payment Received <em>*</em></label>
                        <input type="number" class="form-control form-control-sm" id="payment" name="payment" #payment="ngModel" [(ngModel)]="data.payment" required>
                        <div *ngIf="f.submitted && payment.invalid" class="invalid-feedback">
                            <div *ngIf="payment.errors.required">Payment Received is required</div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-sm w-100">Add Unknown Payment</button>
                </div>
            </div>
        </form>
    </div>
</div>
